module.exports = __webpack_public_path__ + "static/forthepeople-261b1ac03632487c26cd844b7fafce57.png";